import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/two-column-layout.module.css';

import type { ITwoColumnLayout } from './types';

const TwoColumnLayout = ({
  childrenLeft,
  childrenRight,
  headline,
  layout = '20-80',
  showDivider,
  className,
  ...props
}: ITwoColumnLayout) => {
  if (!childrenLeft && childrenRight) return null;

  // Default behavior: show divider for 30-70 layout, hide for 20-80 layout
  const shouldShowDivider = showDivider === undefined ? layout === '30-70' : showDivider && layout === '30-70';
  
  const layoutClass = layout === '20-80' ? styles.layoutL20R80 : styles.layoutL30R70;

  return (
    <div className={generateClassName(['grid', layoutClass, className])} {...props}>
      {headline && (
        <div className={styles.headlineContainer}>
          <h2 className={styles.headline}>
            {headline}
          </h2>
        </div>
      )}
      
      <div className={styles.columnsContainer}>
        <div className={styles.leftColumn}>
          {childrenLeft}
        </div>
        
        {shouldShowDivider && <div className={generateClassName([styles.divider, 'twoColumnLayoutDivider'])} />}
        
        <div className={styles.rightColumn}>
          {childrenRight}
        </div>
      </div>
    </div>
  );
};

export default TwoColumnLayout; 
